// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__VmuXY","closeIcon":"styles_closeIcon__54-25"};